import { Injectable } from '@angular/core';
import { CustomTranslateService } from '@services/common/custom-translate.service';
import { MessageService } from 'primeng/api';
import { forkJoin, Observable } from 'rxjs';
import { UtilsService } from './utils.service';

interface Message {
    summary?: string;
    details: string;
    placeholderValue?: { [key: string]: string };
    life?: number;
}

@Injectable({
    providedIn: 'root',
})
export class ToastService {
    constructor(
        private _messageService: MessageService,
        private translateService: CustomTranslateService,
        private utilsService: UtilsService,
    ) {}

    clearMessageQueue() {
        this._messageService.clear();
    }

    private createMessage(msg: Message, severity: string, styleClass: string, clearQueue?: boolean): void {
        if (clearQueue) this.clearMessageQueue();

        const summary: string | string[] = msg.summary
            ? this.translateService.instant(msg.summary)
            : this.translateService.instant(msg.details, msg.placeholderValue);

        const detail: string | undefined | string[] = !msg.summary
            ? undefined
            : this.translateService.instant(msg.details, msg.placeholderValue);

        this._messageService.add({
            severity,
            summary: this.utilsService.handleTranslation(summary),
            detail: this.utilsService.handleTranslation(detail as string),
            life: msg.life ?? this.getDefaultLife(severity),
            styleClass,
        });
    }

    private getDefaultLife(severity: string): number {
        switch (severity) {
            case 'error':
                return 5000;
            case 'warn':
                return 5000;
            default:
                return 2000;
        }
    }

    showSuccess(msg: Message, clearQueue?: boolean): void {
        this.createMessage(msg, 'success', 'bg-green-50 shadow-4', clearQueue);
    }

    showInfo(msg: Message, clearQueue?: boolean): void {
        this.createMessage(msg, 'info', 'border-blue-500 bg-blue-50 shadow-4', clearQueue);
    }

    showWarning(msg: Message, clearQueue?: boolean): void {
        this.createMessage(msg, 'warn', 'border-orange-500 bg-orange-50 shadow-4', clearQueue);
    }

    showError(msg: Message, clearQueue?: boolean): void {
        this.createMessage(msg, 'error', 'bg-red-50 shadow-4', clearQueue);
    }
}
